<template>
  <v-sheet class="text-center pa-sm-and-up-5 rounded-xl" max-width="500">
    <v-col>
      <h1 class="text-h4 mx-auto mb-4 fontGrey--text">
        {{ $t("$vuetify.accounts.pageTexts.login.loginLabel") }}
      </h1>
      <div v-if="!isVerifiedNumber">
        <v-row>
          <v-col cols="8">
            <v-text-field
              dir="ltr"
              outlined
              dense
              background-color="white"
              filled
              v-model="phoneField"
              autofocus
              placeholder="הכנס מס טלפון"
              :hint="placeholder"
              v-mask="'##########'"
              :rules="phoneRules"
              required
              @keyup.enter="sendUserPhone(true)"
            >
            </v-text-field>
          </v-col>
          <v-col cols="4">
            <CountrySelect
              v-model="selectedCountry"
              :outlineSelect="false"
              @selectCountry="handleSelection"
              :newSelection="true"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn
              color="white"
              class="success mx-auto"
              block
              text
              @click="sendUserPhone(true)"
              :disabled="!validPhone"
            >
              {{ $t("$vuetify.accounts.pageTexts.login.sendSms") }}
            </v-btn>
          </v-col>
          <v-col>
            <v-btn
              color="white"
              class="success mx-auto"
              block
              text
              @click="sendUserPhone(false)"
              :disabled="!validPhone"
            >
              {{ $t("$vuetify.accounts.pageTexts.login.call") }}
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div v-else-if="isVerifiedNumber && sendOtp" dir="ltr">
        <v-otp-input v-model="otp" length="4" @finish="onFinish"></v-otp-input>
        <v-btn v-if="dispalyResendOTP" text plain x-large @click="sendUserPhone"
          >{{ $t("$vuetify.accounts.pageTexts.login.resend") }}
        </v-btn>
      </div>
    </v-col>
  </v-sheet>
</template>

<script>
import isNil from "lodash/isNil";
import ceil from 'lodash/ceil'
import map from "lodash/map";
import isEqual from "lodash/isEqual";
import isEmpty from "lodash/isEmpty";
import trimStart from "lodash/trimStart";
import uniq from "lodash/uniq";
import filter from "lodash/filter";
import includes from "lodash/includes";
import cloneDeep from "lodash/cloneDeep";
import compact from "lodash/compact";
import concat from 'lodash/concat'
import find from 'lodash/find'
import { mapActions, mapGetters } from "vuex";
import boolMixin from "@/mixins/boolMixin.js";
import apiCalls from "@/mixins/apiCalls.js";
import inputRules from "@/mixins/inputRules";
import fetchUser from "@/mixins/fetchUser.js";
// 0587100100 Tzika
// 0549545522 Yehi
// 0553231243 some client  ?
// 0552536535 works...
// 972553313427אסתיkt
// LOBO
// 0553314292
// 0548100990
// 972546384340 Larry
export default {
  name: "LoginDialog",
  mixins: [boolMixin, apiCalls, inputRules, fetchUser],
  components: {
    CountrySelect: () =>
      import("@/components/CommonComponents/Selects/CountrySelect"),
  },
  data() {
    return {
      placeholder: "0553302411",
      selectedCountry: null,
      phoneField: null,
      isVerifiedNumber: false,
      sendOtp: false,
      otp: null,
      dispalyResendOTP: false,
      timerEnabled: false,
      timerCount: 30,
      items: null,
      users: null,
      itemsToHide: [],

    };
  },
  computed: {
    ...mapGetters({
      getAccountInformation: "getAccountInfo",
      getDetailedUsers: "getDetailedUsersList",
    }),
    accountInfo() {
      return this.getAccountInformation;
    },
    detailedUsersList() {
      return this.getDetailedUsers;
    },
    userPhone() {
      return this.selectedCountry.dial_code + trimStart(this.phoneField, "0");
    },
    validPhone() {
      return this.selectedCountry &&
        this.phoneField &&
        this.phoneRules[1](this.phoneField) === true
        ? true
        : false;
    },
  },
  watch: {
    timerEnabled(value) {
      if (value) {
        this.dispalyResendOTP = false;
        setTimeout(() => {
          this.timerCount--;
        }, 1000);
      }
    },
    timerCount(value) {
      if (value > 0 && this.timerEnabled) {
        setTimeout(() => {
          this.timerCount--;
        }, 1000);
      } else {
        this.dispalyResendOTP = true;
        this.pause();
      }
    },    
  },
  methods: {
    ...mapActions([
      "setProfile",
      "setUserProfile",
      "setAccount",
      "setAccountUsers",
      "setAccountOwner",
      "setDetailedUsersList",
      "setInactiveUsers",
      'setAccountPhoneForValidation',
      'setAuthId',
      'setAuthToken',
      'setAdminAccount'
    ]),
    async sendUserPhone(flag) {
      const appAction = true;
      const functionName = "send_otp";
      const reqBody = {
        number: this.userPhone, // required
        method: flag ? "SMS" : "CALL", // SMS | CALL - req
      };
      const data = await this.makeApiRequest(appAction, functionName, reqBody);
      if (data.error_code === 200) {
        this.isVerifiedNumber = true;
        this.sendOtp = true;
      }
      this.play();
    },
    async onFinish() {
      this.dataValue = true
      const appAction = true;
      const functionName = "validate_otp";
      const reqBody = {
        number: this.userPhone, //required
        code: this.otp, //required
        device_details: {},
        registration: true, //if it's registration
      };
      const data = await this.makeApiRequest(appAction, functionName, reqBody);
      // console.log('data : ', data.data);
      if (data.error_code === 200) {
        if(data.data.has_admin) this.$store.dispatch("setAdminAccount", data.data);
        this.$store.dispatch("setAccount", data.data);
        this.$store.dispatch("setAuthId", data.data.auth_id);
        this.$store.dispatch("setAuthToken", data.data.token);
        await this.getAccountInfo();   
        this.loadForAllSubscribers();
      }
      
    },
    // mixin
    async getAccountInfo() {
      const appAction = false;
      const functionName = "get_account_info";
      const reqBody = {
        account_id: this.account.domain_id,
      };
      try {
        const data = await this.makeApiRequest(
          appAction,
          functionName,
          reqBody
        );
        if (data.error_code === 200) {
          await this.$store.dispatch("setAccountInfo", data.data);
          this.accountInfo;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getUsers() {
      let accauntUsersPages = this.accountInfo.users_amount / 40
      const appAction = false;
      const functionName = "get_users";
      for(let i = 0; i <= (ceil(accauntUsersPages) -1); i++) {
        const reqBody = {
          account_id: this.account.domain_id,
          page: i
        };
        const data = await this.makeApiRequest(appAction, functionName, reqBody);
        if (data.error_code === 200) {
          this.users = concat(this.users, data.data);
         
        }
        this.users = compact(this.users)
      }
    },
    async loadForAllSubscribers() {
      await this.getUsers();
      await this.getDetailedUsersList();
      if (
        !isNil(this.accountInfo) &&
        isEqual(
          this.accountInfo.profile.contact_phone,
          trimStart(this.userPhone, "+")
        )
      ) {
        this.loadForAccountOwner();
      } else {
        let user = this.findItem();
        if (user[0].is_account_owner) this.loadForAccountOwner();
        else this.loadForSubscriber(user[0]);
      }
    },
    async loadForSubscriber(theUser) {
      await this.$store.dispatch("setAccountOwner", false);
      await this.$store.dispatch("setUserProfile", theUser); //?
      return this.$router.push(`/user/${theUser.domain_user_id}/profile`);
    },
    async loadForAccountOwner() {
      const accountUser = await this.getUser(this.account);
      await this.$store.dispatch("setUserProfile", accountUser);
      this.$store.dispatch("setAccountOwner", true);
      this.$store.dispatch("setAccountUsers", this.users);
      this.$router.push(`/account/${this.account.domain_id}/profile`);
    }, 
    //to mixin ?
    accountOwnerUser(user) {
      if( isEqual(this.account.domain_user_id, user.domain_user_id)) return user
      else return 
    },  
    async getDetailedUsersList() {
      this.items = await Promise.all(
        this.users.map(async (el) => {
          const response = await this.getUser(el);
          return await response;
        })
      ); 
      let accountOwnerForPhone = find( this.items, 'is_account_owner')
      let phone = '+' + this.findPhone(accountOwnerForPhone)
      await this.$store.dispatch("setAccountPhoneForValidation", phone);
      let active = filter(this.items, el => { return this.filter(el) })
      let accountOwner = find( active, el => { return this.accountOwnerUser(el)} )
      active = concat([accountOwner], active)
      active = uniq(active)
      this.$store.dispatch('setDetailedUsersList', active)
      this.$store.dispatch('setInactiveUsers', this.itemsToHide)
      return;
    },
    filter(user ) {
      if (user.active && (user.endpoint_amount > 0) && !isEmpty(user.base_package)) return user
      else this.itemsToHide.push(user)
    },
    findItem() {
      let number = trimStart(this.userPhone, "+");
      let items = cloneDeep(this.items);
      let item = map(items, (el) => {
        if (el.main_cid == number) return el;
        if (el.profile.contact_phone == number) return el;
        if (includes(el.main_cid_options, number)) return el;
      });
      return compact(item);
    },
    findPhone(accountOwnerForPhone) {
      // console.log('findPhone(accountOwnerForPhone)', accountOwnerForPhone );
      let phone
      if(accountOwnerForPhone.main_cid) phone = accountOwnerForPhone.main_cid
      if(accountOwnerForPhone.profile.contact_phone) phone = accountOwnerForPhone.profile.contact_phone
      if(accountOwnerForPhone.main_cid_options.length > 0) phone = accountOwnerForPhone.main_cid_options[0]
      return phone
    },
    play() {
      this.timerEnabled = true;
    },
    pause() {
      this.timerEnabled = false;
      this.timerCount = 10;
    },
    handleSelection(country) {
      this.selectedCountry = country;
    },
  },
};
</script>
